import { Column } from 'primereact/column'
import { useState, useRef } from 'react'
import { useIntl } from 'react-intl'
import { Combobox, CustomTable, InputTextCustom, InputDate } from 'medere-ui-framework'
import "./AskForLotsAndExpirationDatePanel.css"


function AskForLotsAndExpirationDatePanel() {

    console.log("EL PANEL SE VE")

    type ProductDTO = {
        description: string;
    };
    type LotDTO = {
        lotName: string;
    };
    
    const intl = useIntl();
    const today = new Date();
    const [dateFrom, setDateFrom] = useState(new Date());
    const [dateTo, setDateTo] = useState(new Date(today.getFullYear() + 1, today.getMonth(), today.getDate()));
    const [product, setProduct] = useState<ProductDTO>({description:''});
    const [lot, setLot] = useState<LotDTO>({lotName:''});
    const customTableRef:any = useRef(null);

  return (
    <div className='px-4 flex flex-column viewContainer'>
        <div>
            <p style={{marginBottom:'16px', color:'black'}}className='infoText subTitle'>Información de lotes</p>
            <div>
                <div className='inputs-container'>
                    <Combobox className='margin-16' value={product} setValue={(value:any)=>setProduct(value)} getItems={getProducts} optionLabel='description' label={intl.formatMessage({id:'Product'})} placeholder={intl.formatMessage({id:'SelectProduct'})} params={{stockItemDescription:product?.description}} /> 
                    <InputTextCustom className='margin-16' value={lot.lotName} label={intl.formatMessage({id:'Lot'})} onChange={(value:any)=>setLot({lotName:value.target.value})} />
                    <InputDate className='margin-16' label={intl.formatMessage({id:'ExpirationFrom'})} value={dateFrom} onChange={(e:any) => setDateFrom(e.value)}/>
                    <InputDate className='margin-16' label={intl.formatMessage({id:'ExpirationTo'})} value={dateTo} onChange={(e:any) => setDateTo(e.value)}/>
                </div> 
                <CustomTable idTable='tableLotsInformacion' getItems={getLotsInformation} showGridlines hideFiltersButton className='crudTable editable-cells-table' filterRow ref={customTableRef} params={{stockItemDescription:product?.description, lotName:lot.lotName, dateFrom:dateFrom?.toISOString(), dateTo:dateTo?.toISOString()}} itemSize = {70}>
                    <Column field='lotname' header={intl.formatMessage({id:'LotName'})} className='column'/>
                    <Column field='expirationdate' header={intl.formatMessage({id:'ExpirationDate'})} className='column'/>
                    <Column field='stockitemdescription' header={intl.formatMessage({id:'Product'})} className='column'/>
                    <Column field='provider' header={intl.formatMessage({id:'Provider'})} className='column'/>
                    <Column field='movementtype' header={intl.formatMessage({id:'MovementType'})} className='column'/>
                    <Column field='arrivaldate' header={intl.formatMessage({id:'ArrivalDate'})} className='column'/>
                    <Column field='quantity' header={intl.formatMessage({id:'Quantity'})} className='column' />
                    <Column field='user' header={intl.formatMessage({id:'User'})} className='column' />
                </CustomTable>
            </div>
        </div>
    </div>
  )
}
import { getLotsInformation, getProducts } from '../../servicesHooks/Stock/useStockService'
export default AskForLotsAndExpirationDatePanel
